

import {
  AppChart,
  AppBarChart,
  AppPieChart
} from '../app';

import { Fragment, useEffect, useState } from 'react';
import Request from '../../common/Request';
import { Select, FormControl, InputLabel, MenuItem, Card, CardHeader, ToggleButtonGroup, ToggleButton, Grid, Stack, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SmallSumMetrics from './SmallSumMetrics';

// ----------------------------------------------------------------------
export default function  MultiChart(props){

  const [eventName, setEventName ] = useState(null);
  const [eventNames, setEventNames ] = useState(null);

  const [chartType, setChartType ] = useState("line");


  const [chartData, setChartData ] = useState(null);
  const [pieChartData, setPieChartData ] = useState(null);


  const filterData = props.filterData;


  const {t, i18n} = useTranslation();

  useEffect(async () => {
    var req = await Request.Get(Request.Paths.GetChartMeta, filterData);
    if (req.ok && req.data.EventNames.length > 0){
      setEventName(req.data.EventNames[0]);
      setEventNames(req.data.EventNames);
      
    }
  }, []);

  useEffect(async () => {

    console.log("Requesting Chart Data", filterData);

    setChartData(null);



    if (filterData.isValid && eventName != null){

      filterData.EventName = eventName;

      if (chartType == "line" || chartType == "pie"){
        var req = await Request.Post(Request.Paths.GetChart, filterData);
        if (req.ok){
      
            // var data = o.map(p => {
            //   return { x : new Date(p.Year + '-' + p.Month + '-' + p.Day + ' ' + p.Hour + ':00').getTime(), y:p.Value};
            // });
    
            var data = req.data.map( p=> {
              return { 
                name : p.Grouping,
                data : p.Entries.map(p => {
                  //     return { x : new Date(p.TimeStamp ).getTime(), y:p.Value};
                      var date = new Date(p.Year + '-' + p.Month + '-' + p.Day );
                      var userTimezoneOffset = date.getTimezoneOffset() * 60000;
                      date = new Date(date.getTime() - userTimezoneOffset);
                      return { x : date, y:p.Value};
                    })
              }
            });

            setChartData(data);


            //old non grouped setter
        //     var data = req.data.map(p => {
        //  //     return { x : new Date(p.TimeStamp ).getTime(), y:p.Value};
        //       return { x : new Date(p.Year + '-' + p.Month + '-' + p.Day ).getTime(), y:p.Value};
        //     });  
            // setChartData([{
            //   name: 'Team A',
    
            //   data: data
            // }]);

          // console.log(data.map( p => p.x.toString()));
        }
        else
        {
            setChartData(null);
        }
      }
      else if (chartType == "bar"){
        var req = await Request.Post(Request.Paths.GetDailyDistribution, filterData);
        if (req.ok){
  
            // var data = req.data.map(p => {
            //   return { x : p.Hour, y:p.Value};
            // });
    
            var data = req.data.map( p=> {
              return { 
                name : p.Grouping,
                data : p.Entries.map(p => {
                  return { x : p.Hour, y:p.Value};
                  //     return { x : new Date(p.TimeStamp ).getTime(), y:p.Value};
            //return { x : new Date(p.Year + '-' + p.Month + '-' + p.Day ).getTime(), y:p.Value};
                     })
              }
            });
  
            setChartData(data);
          //  console.log(data);
        }
        else
        {
          setChartData(null);
        }
  
      }

      
    }

  
  }, [filterData, eventName, chartType]);


  return <Fragment> 

      <SmallSumMetrics selectedMetric={eventName} filterData={filterData} cardClicked={ (name) => { setEventName(name); }}  />
      


      <Grid item xs={12} sm={12} md={12}>
        <Card>
      
          <Stack className="blueOnWhiteContainer" direction="row" spacing={5}>


              { eventName != null && eventNames != null &&
                <Box className="blueOnWhiteBox"> 
                  <FormControl>
                    {/* <InputLabel id="demo-simple-select-label">Event</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"

                      value={eventName}
                      onChange={(event) => { setEventName(event.target.value); }} >
                      {
                        eventNames.map((name) =>
                        <MenuItem key={name} value={name}>{t(name)}</MenuItem>
                        )
                      }
                      {/* <MenuItem value={"SlideRide"}>SlideRide</MenuItem>
                      <MenuItem value={"Register"}>Register</MenuItem> */}
                    </Select>
                  </FormControl> 
                </Box>}
              
                <Box className="blueOnWhiteBox" item sx={{ margin: "5px"}} >
                  <ToggleButtonGroup
                      color="primary"
                      value={chartType}
                      exclusive
                      onChange={ (event, value) => { setChartType(value); }}>
                    <ToggleButton value="line">{t("line")}</ToggleButton>
                    <ToggleButton value="bar">{t("bar")}</ToggleButton>
                    <ToggleButton value="pie">{t("pie")}</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
            </Stack>



          {/* <CardHeader title={"props.title"} subheader={"props.subtitle"} /> */}

            { chartType == "line" && <AppChart data={chartData} title={eventName} height={600}  /> } 
            { chartType == "bar"  &&  <AppBarChart data={chartData} title={eventName} height={600} /> }
            { chartType == "pie"  &&  <AppPieChart data={chartData} title={eventName} height={600} /> }

         
        </Card>
      </Grid>

  </Fragment>
  
}